export const digitalReadinessLevels: string[] = [
  'PDF Only',
  'Map Pack Ready',
  'Lighting Ready',
  'Full VTT Module'
];
